import { render, staticRenderFns } from "./ClassifyManage.vue?vue&type=template&id=0fcdc28c&scoped=true"
import script from "./ClassifyManage.vue?vue&type=script&lang=js"
export * from "./ClassifyManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcdc28c",
  null
  
)

export default component.exports